module.exports = __webpack_public_path__ + "img/LIN.5c822b7c.svg";